import React from "react";
import { Typography, Box } from "@mui/material";
import Header from '../header/header';
import Footer from '../commun/Footer';
import SidebarFichesMetiers from "../commun/SidebarFichesMetiers";
import "./Cgu.css";

const FicheUIUXDesigner = () => (
  <>
    <Header />
    <div className="fiche-layout">
      <Box className="fiche-main" component="section">
        <Typography variant="h5" gutterBottom>
          🎨 Recruter un UI/UX Designer
        </Typography>
        <Typography variant="h6" gutterBottom>
          Description du poste
        </Typography>
        <Typography paragraph>
          Le UI/UX Designer conçoit des expériences utilisateurs intuitives et des interfaces graphiques attractives. Il travaille à l’intersection du design, de l’ergonomie et du digital pour créer des parcours fluides, engageants et adaptés aux besoins des utilisateurs. Il intervient dès la phase de conception d’un produit (application, site, plateforme…) jusqu’à son optimisation post-lancement.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Missions principales
        </Typography>
        <ul className="cgu-list">
          <li>Analyser les parcours utilisateurs et réaliser des recherches UX</li>
          <li>Créer des wireframes, prototypes et maquettes fonctionnelles</li>
          <li>Définir une charte graphique cohérente avec l’identité de marque</li>
          <li>Optimiser l’ergonomie et l’accessibilité des interfaces</li>
          <li>Tester les interfaces (user testing, A/B testing) et intégrer les retours</li>
          <li>Collaborer étroitement avec les développeurs et chefs de produit</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Compétences clés
        </Typography>
        <ul className="cgu-list">
          <li>Outils : Figma, Adobe XD, Sketch, InVision, Zeplin</li>
          <li>Méthodologies : Design Thinking, Lean UX, Atomic Design</li>
          <li>Sens de l’ergonomie, du détail et de l’esthétique</li>
          <li>Capacité à documenter et défendre ses choix de design</li>
          <li>Bonnes bases HTML/CSS (souhaité)</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Profils recherchés / Niveaux d’expérience
        </Typography>
        <ul className="cgu-list">
          <li>Junior : bonnes bases graphiques, premiers projets web/app</li>
          <li>Confirmé : maîtrise complète du process UX/UI, autonomie sur des produits digitaux</li>
          <li>Senior : encadrement d’équipe design, stratégie d’expérience globale, direction artistique</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Tarifs / TJM indicatifs
        </Typography>
        <ul className="cgu-list">
          <li>Junior : 300–400 € / jour</li>
          <li>Confirmé : 450–600 € / jour</li>
          <li>Senior / Lead UX : 650–800 € / jour</li>
        </ul>
      </Box>
      <Box className="fiche-sidebar" component="aside">
        <SidebarFichesMetiers />
      </Box>
    </div>
    <Footer />
  </>
);

export default FicheUIUXDesigner;
